import { CostDocumentListItem } from "@/models/api/costDocuments/CostDocumentList";
import { Expose, Type } from "class-transformer";
import { IsNumber, ValidateNested } from "class-validator";
import { CostDocumentItem } from "@/models/api/costDocuments/CostDocumentDetails";
import { CostDocumentContractor } from "@/models/api/costDocuments/CostDocumentEdit";

export class CostDocumentToPair extends CostDocumentListItem {
  @IsNumber()
  @Expose()
  amount!: number;
  @IsNumber()
  @Expose()
  exchangeRate!: number;

  @ValidateNested()
  @Type(() => CostDocumentContractor)
  @Expose()
  contractor!: CostDocumentContractor;
  @ValidateNested()
  @Type(() => CostDocumentItem)
  @Expose()
  costDocumentItems!: Array<CostDocumentItem>;
}
